import { render, staticRenderFns } from "./updateBLKN.vue?vue&type=template&id=0a90f9dc&lang=pug&"
import script from "./updateBLKN.vue?vue&type=script&lang=js&"
export * from "./updateBLKN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports